import { Image, Page, Text, View } from '@react-pdf/renderer';
import { useQuotePdfContext } from '@ui/pages/QuoteBuilder/hooks';
import { styles } from '@ui/pdfs/styles';

import { QuoteLink } from './components/QuoteLink';
import { CustomerQuotePdfTemplate } from './template';

export function CustomerQuote() {
  const { quoteForm: form } = useQuotePdfContext();

  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.row}>
        <View style={[styles.section, styles.alignCenter]}>
          <Image
            src={'/images/CSC/CENTURY_SPRING_RGB_PRIMARY_LOGO_AW.png'}
            // the default styles.logo is specialized for CAP
            // customize logo style to preserve logo aspect ratio and margins
            style={[styles.logo, { height: '42px' }]}
          />
        </View>
        <View style={styles.section}>
          <Text style={styles.bold}>Century Spring Corp. / MW Ind.</Text>
          <Text>5959 Triumph Street</Text>
          <Text>Commerce CA 90040</Text>
          <Text>Phone (800) 237-5225</Text>
          <Text>Fax 213-749-8569</Text>
        </View>
        <View style={[styles.section, styles.alignCenter, styles.maxWidthFull]}>
          <Text style={[styles.quoteNumber, styles.bold]}>
            Quotation {form.quoteId}
          </Text>
          <Text style={styles.textSmall}>
            Please refer to the quotation number when ordering
          </Text>
          <QuoteLink />
        </View>
      </View>
      <CustomerQuotePdfTemplate
        showPartDescription
        showDrawing
        showCustomerPartId
      />
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>
            These items are manufactured and quoted to the catalog
            specifications within S.M.I tolerances only. Only standard C of C is
            provided for catalog items
          </Text>
          <Text style={[styles.bold, styles.textSmall]}>
            ** FAIR, DFAR, Traceability or Material Certs will not be provided.
            PARTS ARE IN STOCK UNLESS NOTED ***Parts that are in stock can ship
            immediately*** Prices are valid for 30 days.
          </Text>
          <Text style={[styles.bold, styles.textSmall]}>
            Our minimum is $25.00 or a $15.00 small order fee will be charged.
            Orders over $1000 in value are considered NCNR. All major credit
            card are accepted. Freight charges are calculated at time of
            shipping. 20% restocking fee applies to all parts returned within 30
            days of delivery. We accept scheduled orders with up to 9 releases
            in a 12 month period.
          </Text>
          <Text>
            We accept scheduled shipments and blanket orders up to 12 months.
          </Text>
        </View>
      </View>
    </Page>
  );
}
